<template>
  <div>
    <v-menu v-model="menu" :offset-y="true" :close-on-content-click="false" max-width="70%" :disabled="disabled">
      <template v-slot:activator="{ on }">
        <v-text-field clearable append-icon="mdi-calendar-clock" :value="transformedValue" solo flat hide-details dense
        @click:clear="cancelSelection"  background-color="#E7E7FF" placeholder="Select Date & Time" v-on="on" readonly :disabled="disabled" />
      </template>
      <v-card style="padding: 22px 24px 22px 0;" v-if="!disabled">
        <div style="display: flex; gap: 5px">
          <v-date-picker color="#050D92" v-model="selectedDate" no-title scrollable @input="onDateInput" />
          <section>
            <div style="display: flex; gap: 5px; justify-content: space-around; margin-top: 10px;">
              <!-- Hours -->
              <div class="picker-column">
                <div class="column-title">Hour</div>
                <v-list class="scrollable-list">
                  <v-list-item-group v-model="selectedHours" color="#050D92">
                    <v-list-item v-for="(hour, i) in hours" :key="`hour-${i}`" :value="hour">
                      <v-list-item-content>
                        <v-list-item-title>{{ hour }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </div>
              <!-- Minutes -->
              <div class="picker-column">
                <div class="column-title">Minute</div>
                <v-list class="scrollable-list">
                  <v-list-item-group v-model="selectedMinutes" color="#050D92">
                    <v-list-item v-for="(minute, i) in minutes" :key="`minute-${i}`" :value="minute">
                      <v-list-item-content>
                        <v-list-item-title>{{ minute }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </div>
              <!-- AM/PM -->
              <div class="picker-column">
                <div class="column-title">AM/PM</div>
                <v-list class="scrollable-list">
                  <v-list-item-group v-model="selectedPeriods" color="#050D92">
                    <v-list-item v-for="(period, i) in periods" :key="`period-${i}`" :value="period">
                      <v-list-item-content>
                        <v-list-item-title>{{ period }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </div>
            </div>
          </section>
        </div>
        <div style="margin-top: -5px; text-align: center">
          <v-btn small dark color="#FF4F1F" @click="confirmSelection" :disabled="disabled">
            Save
          </v-btn>
          <v-btn small outlined color="#FF4F1F" style="margin-left: 10px" @click="cancelSelection" :disabled="disabled">
            Clear
          </v-btn>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { minutesArray, hoursArray } from "../../../Constants/Utils/Statics";
export default {
  name: "DateTimePicker",
  props: {
    value: { type: String, default: "" },
    width: { type: [String, Number], default: "30%" },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      menu: false,
      selectedDate: null,
      selectedHours: "",
      selectedMinutes: "",
      selectedPeriods: "",
      hours: hoursArray,
      minutes: minutesArray,
      periods: ["AM", "PM"]
    };
  },
  computed: {
    transformedValue() {
      if (!this.value) return "";
      try {
        const date = new Date(this.value);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const period = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        return `${day}-${month}-${year} ${String(hours).padStart(2, '0')}:${minutes} ${period}`;
      } catch {
        return "";
      }
    },
    timeSegments() {
      return [
        { label: "Hour", options: this.hours, model: this.selectedHours },
        { label: "Minute", options: this.minutes, model: this.selectedMinutes },
        { label: "AM/PM", options: this.periods, model: this.selectedPeriods }
      ];
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (!newVal) return;
        // console.log('newVal', newVal);
        const date = new Date(newVal);
        // console.log('date', date);
        this.selectedDate = date.toISOString().split("T")[0];
        // console.log('this.selectedDate', this.selectedDate);
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const period = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        this.selectedHours = String(hours).padStart(2, '0');
        this.selectedMinutes = minutes;
        this.selectedPeriods = period;
      }
    }
  },
  methods: {
    confirmSelection() {
      if (!this.selectedDate) return;
      console.log('this.selectedDate', this.selectedDate);
      const [year, month, day] = this.selectedDate.split("-");
      console.log('year', year);
      console.log('month', month);
      console.log('day', day);
      console.log('this.selectedHours', this.selectedHours);
      console.log('this.selectedMinutes', this.selectedMinutes);
      let hours = parseInt(this.selectedHours || "01");
      const minutes = this.selectedMinutes || "00";
      const period = this.selectedPeriods || "AM";
      if (period === "PM" && hours < 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;
      const finalDate = new Date(`${year}-${month}-${day}T${String(hours).padStart(2, '0')}:${minutes}`);
      this.$emit("input", finalDate.toISOString());
      this.menu = false;
    },
    cancelSelection() {
      this.selectedDate = null;
      this.selectedHours = "";
      this.selectedMinutes = "";
      this.selectedPeriods = "";
      this.$emit("input", "");
      this.menu = false;
    },
    onDateInput(value) {
      this.selectedDate = value;
    }
  }
};
</script>
<style scoped>
.scrollable-list {
  height: 200px;
  overflow-y: auto;
  scroll-behavior: smooth;
}
.scrollable-list::-webkit-scrollbar {
  width: 2px;
}
.scrollable-list::-webkit-scrollbar-track {
  background: transparent;
}
.scrollable-list::-webkit-scrollbar-thumb {
  background: #898888;
}
.picker-column {
  border: 1px solid #A8A8A8;
  border-radius: 4px;
  padding: 5px;
}
.column-title {
  text-align: center;
  padding: 2px;
  font-size: 16px;
  font-weight: 600;
}
</style>
